var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.22242 10.3763L4.10317 12.495L4.088 0H2.92133L2.9365 12.4874L0.824833 10.3757L0 11.2L2.28608 13.4861C2.44859 13.6486 2.64152 13.7775 2.85386 13.8655C3.0662 13.9535 3.29379 13.9988 3.52363 13.9988C3.75346 13.9988 3.98105 13.9535 4.19339 13.8655C4.40573 13.7775 4.59866 13.6486 4.76117 13.4861L7.04725 11.2L6.22242 10.3763Z",
    fill: "#586370"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadArrowIcon);
export default __webpack_public_path__ + "static/media/download-arrow-icon.ee7bf86db636b96cb48eb09a1fd68502.svg";
export { ForwardRef as ReactComponent };